export default __webpack_public_path__ + "static/media/cuadricula.b9123ae4.svg";